import purchaseFullcont from "./purchase-fullcont.html";

const dialog = require("../../../../../../components/dialog/dialog");
const dialogP = require("../providerProfit-dialog");
const fullcontEntity = require("../../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../../components/fullcont/fullcont-handler");
const purchaseDt = require("../../purchase/purchase-dt");
const purchaseMenu = require("./purchase-menu");
const handler = require("./purchase-fullcont-handler");
const jumperHandler = require("./purchase-fullcont-jumper-handler");
const dateHandler = require("./purchase-fullcont-date-handler");
const pdfHandler = require("./purchase-fullcont-pdf-handler");
const emailHandler = require("./purchase-fullcont-email-handler");
const labelHandler = require("./purchase-fullcont-label-handler");
const calculateHandler = require("./purchase-fullcont-calculate-handler");
const otherfieldHandler = require("./purchase-fullcont-otherfield-handler");
const defaultvalueHandler = require("./purchase-fullcont-defaultvalue-handler");
const cautionHandler = require("./purchase-fullcont-caution-handler");
const { formCopy } = require("./purchase-fullcont-form");
const { form } = require("./purchase-fullcont-form");
const { purchaseMT } = require("./purchase-fullcont-multitable");
const restriction = require("./purchase-fullcont-restriction");
const backControl = require("../../../../../../js/back-control"); // Ajusta la ruta según tu estructura


// const purchaseMT   = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
var htmlFc2 = {};
var HTMLwasSelected = false;
var input_send_email = false;
var scrimFullcont2

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "purchase", //database table name****
    "purchase", //dest entity on js
    "purchase-fullcont3",
    purchaseFullcont,
    form,
    formCopy,
    purchaseMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc2
  );

  HTMLwasSelected = true;

  // htmlFc2.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc2)
} /**/

export function start(detail) {
  //console.log('purchase-dt 5>', purchaseMT)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addBillingDate: {
    start: (detail) => {
      dateHandler.addBillingDate(detail, htmlFc2);
    },
  },
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc2);
    },
  },
  calculate_values_p_vs_investment: {
    start: (detail) => {
      calculateHandler.calculate_values_p_vs_investment(detail, htmlFc2);
    },
  },
  calculate_values_p_vs_item: {
    start: (detail) => {
      calculateHandler.calculate_values_p_vs_item(detail, htmlFc2);
    },
  },
  calculate_values_p_vs_lost: {
    start: (detail) => {
      calculateHandler.calculate_values_p_vs_lost(detail, htmlFc2);
    },
  },
  calculate_total_lost_returned: {
    start: (detail) => {
      calculateHandler.calculate_total_lost_returned();
    },
  },
  calculateGrandTotal: {
    start: (detail) => {
      calculateHandler.calculateGrandTotal(htmlFc2);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc2);
    },
  },
  changeBilleOn: {
    start: (detail) => {
      handler.changeBilleOn();
    },
  },
  checkOtherCostItem: {
    start: (detail) => {
      calculateHandler.checkOtherCostItem(detail, htmlFc2);
    },
  },
  cogsPercent: {
    start: (detail) => {
      handler.cogsPercent(detail, htmlFc2);
    },
  },
  creationCaution: {
    start: (detail) => {
      cautionHandler.creationCaution(detail, htmlFc2);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc2);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc2);
    },
  },
  disableopcion: {
    start: (detail) => {
      handler.disableopcion(detail);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc2);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      purchaseMenu.start(detail, "htmlDt", htmlFc2);
    },
  },
  goToQtyField: {
    start: (detail) => {
      handler.goToQtyField(detail, htmlFc2);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc2);
    },
  },
  insertDateExpenses: {
    start: (detail) => {
      dateHandler.insertDateExpenses(detail, htmlFc2);
    },
  },
  insertDeliveredDate: {
    start: (detail) => {
      dateHandler.insertDeliveredDate(detail, htmlFc2);
    },
  },
  jumperToSale: {
    start: (detail) => {
      jumperHandler.jumperToSale(detail, htmlFc2);
    },
  },
  jumperToSendPayment: {
    start: (detail) => {
      jumperHandler.jumperToSendPayment(detail, htmlFc2);
    },
  },
  labelgenerator: {
    start: (detail) => {
      labelHandler.labelgenerator(detail);
    },
  },
  noDecimal: {
    start: (detail) => {
      calculateHandler.noDecimal(detail, htmlFc2);
    },
  },
  otherFieldInvestor: {
    start: (detail) => {
      otherfieldHandler.otherFieldInvestor(detail, htmlFc2);
    },
  },
  otherFieldItem: {
    start: (detail) => {
      otherfieldHandler.otherFieldItem(detail, htmlFc2);
    },
  },
  otherFieldProvider: {
    start: (detail) => {
      otherfieldHandler.otherFieldProvider(detail, htmlFc2);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc2, processAfterPrepareAdd);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc2);
    },
  },
  printlabel: {
    start: (detail) => {
      labelHandler.printlabel();
    },
  },
  printlabeldt: {
    start: (detail) => {
      labelHandler.printlabeldt(detail);
    },
  },
  purchasePrintPdf: {
    start: (detail) => {
      pdfHandler.purchasePrintPdf(detail, htmlFc2);
    },
  },
  purchaseSendEmail: {
    start: (detail) => {
      emailHandler.purchaseSendEmail(detail, htmlFc2);
    },
  },
  purchaseTrackingMail: {
    start: (detail) => {
      emailHandler.purchaseTrackingMail(detail, htmlFc2);
    },
  },
  removeItem: {
    start: (detail) => {
      restriction.removeItem(htmlFc2);
    },
  },
  restirctionClick: {
    start: (detail) => {
      restriction.restirctionClick(detail, htmlFc2);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      cautionHandler.beforeupdate(detail, htmlFc2);
    },
  },
  selectOne: {
    start: (detail) => {
      selectOne(detail, htmlFc2);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      selectOneNoCheck(detail, htmlFc2);
    },
  },
  sellingPrice: {
    start: (detail) => {
      calculateHandler.sellingPrice(detail, htmlFc2);
    },
  },
  updateCaution: {
    start: (detail) => {
      cautionHandler.beforeupdate(detail, htmlFc2);
    },
  },
  verifyDate: {
    start: (detail) => {
      dateHandler.verifyDate(detail, htmlFc2);
    },
  },
  beforeAutocomplete: {
    start: (detail) => {
      handler.beforeAutocomplete(detail, htmlFc2);
    },
  },
  otherFieldItemLost: {
    start: (detail) => {
      otherfieldHandler.otherFieldItemLost(detail, htmlFc2);
    },
  },
  showMtlost: {
    start: (detail) => {
      handler.showMtlost(htmlFc2);
    },
  },
  showFullcont: {
    start: (detail) => {
      showFullcont(detail);
    },
  },
  hide2: {
    start: (detail) => {
      hide2(detail);
    },
  },
}; /**/

function showFullcont(detail, callback) {
  const isWideScreen = window.innerWidth >= 1800;

  let fullcont = document.getElementById(detail.id);
  if (isWideScreen) {
    fullcontEntity.selectOneNoCheck(
      detail,
      htmlFc2,
      processAfterSelectOne
    );
    isscrimFullcont2TemporarilyHidden = true;
  } else {
    fullcontEntity.selectOneNoCheck(
      detail,
      htmlFc2,
      processAfterSelectOne
    );
    scrimFullcont2 = document.getElementById("scrim_fullcont2");
    scrimFullcont2.classList.add("scrim-show");
    isscrimFullcont2TemporarilyHidden = true;
  }

  const pageAccounts = document.getElementById(`${detail.dest}-page`);
  pageAccounts.appendChild(fullcont); // Lo agrega al body
}

function hide2(detail) {
  //console.log('hide',  detail)
  console.log(scrimFullcont2);
  var elem;

  if (detail.id != undefined) {
    elem = document.getElementById(detail.id);
  } else {
    elem = detail.fullcontHTML;
  }

  // andry
  hideAnimation(elem, scrimFullcont2);
  isscrimFullcont2TemporarilyHidden = false;

  //remove to the url
  backControl.hashSub({ toHide: `fullcont-${detail.id}` });
  //   cleanHash();
  return;
} /**/

function cleanHash() {
  // Obtener el hash actual y dividirlo
  const currentHash = window.location.hash.replace("#", "").split("|");
  // Filtrar elementos vacíos y fullcont
  const cleanedHash = currentHash.filter(
    (item) => item && !item.startsWith("fullcont-")
  );

  // Si hay elementos válidos, reconstruir el hash
  if (cleanedHash.length > 0) {
    window.location.hash = cleanedHash.join("|");
  } else {
    // Si no hay elementos, limpiar completamente el hash
    history.replaceState(null, null, " ");
  }
}

function hideAnimation(elem, scrimFullcont) {
  //console.log(`hideAnimation`, elem)

  const size = window.innerWidth;

  elem.classList.add("fullcont-hide");

  if (size < 1800) {
    scrimFullcont.classList.add("scrim-hide");
  }

  remove(() => {
    elem.classList.remove("fullcont-show");
    elem.classList.remove("fullcont-hide");
    scrimFullcont.classList.remove("scrim-show");
    scrimFullcont.classList.remove("scrim-hide");
  });
}

function remove(callback) {
  setTimeout(() => {
    callback();
  }, 250);
}

function selectOne(detail, htmlFc2) {
  fullcontEntity.selectOne(detail, htmlFc2, processAfterSelectOne);
} /**/

function selectOneNoCheck(detail, htmlFc2) {
  fullcontEntity.selectOneNoCheck(detail, htmlFc2, processAfterSelectOne);
} /**/

function processAfterSelectOne(data, result) {
  handler.dtgenerator(result, htmlFc2);
  handler.itemWithSale(result, htmlFc2);
  handler.verifyPayment(htmlFc2, htmlFc2.fullcontHTML.getAttribute("data-dbid"));
  calculateHandler.fill_InventoryStock_spentCredit(data);
  calculateHandler.calculate_total_lost_returned();
  handler.showLost();
}

//function to send
function editDialog() {
  dialogP.start({dest:"providerProfit", act: "show", id: "saveChanges", entity: "purchase" });
}

function deleteDialog(detail) {
  dialogP.start({
    act: "show",
    dest: "providerProfit",
    id: "deleteElem",
    entity: "purchase",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  purchaseDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc2) {
  fullcontEntity.addOne(detail, htmlFc2, processAfterAdd);
}

function deleteFromDialog(detail, htmlFc2) {
  fullcontEntity.deleteFromDialog(detail, htmlFc2);
  setTimeout(() => {
    purchaseDt.start({
      dest: "purchase",
      elem: "dt",
      act: "select",
      entity: "purchase",
    });
  }, 900);
}

export function processAfterAdd(data, result) {
  handler.showLost();
  //actualizar el array con el inventario
  calculateHandler.fill_InventoryStock_spentCredit(data);
}

function processAfterPrepareAdd() {
  defaultvalueHandler.setDefaultValue(htmlFc2);
  handler.cleandtfullcont(htmlFc2);
  handler.hideLost();
}

/********CONTROL WINDOW RESIZE AND FULLCONT/SCRIM****************/
//avoid potencial error that the user resize the scrim :)
var isscrimFullcont2TemporarilyHidden = false; //andry

window.addEventListener("resize", () => {
  const size = window.innerWidth;

  if (size > 1200 && isscrimFullcont2TemporarilyHidden) {
    // Comportamiento para scrim_fullcont2
    // andry
    console.log(scrimFullcont2);
    if (size > 1800) {
      scrimFullcont2.classList.add("scrim-hide");
      scrimFullcont2.classList.remove("scrim-show");
    } else {
      scrimFullcont2.classList.add("scrim-show");
      scrimFullcont2.classList.remove("scrim-hide");
    }
  }
});

window.addEventListener("resize", () => {
  const size = window.innerWidth;

  // Comportamiento para scrim_fullcont2
  // andry
  if (size > 1800) {
    cleanHash();
  }
});
